import $ from 'jquery';

export function initStories() {
  const $section = $('.stories');

  if (!$section.length) {
    return;
  }

  const $thumbs = $section.find('.stories__thumb');
  const $bgs = $section.find('.stories__bg');
  const $content = $section.find('.stories__content');
  const $heading = $section.find('.stories__heading');
  const $description = $section.find('.stories__description');
  const $author = $section.find('.stories__author');

  const TEXT_FADE = 220;

  let activeIdx = 0;
  let currentTargetUrl = '';

  $thumbs.find('img').on('error', function () {
    const $img = $(this);
    const fallback = $img.closest('.stories__thumb').data('image');

    if (fallback && $img.attr('src') !== fallback) {
      $img.attr('src', fallback);
    }
  });

  function crossfadeBg(src) {
    if (!src) {
      return;
    }

    const $current = $bgs.eq(activeIdx);

    if ($current.attr('src') === src) {
      return;
    }

    const nextIdx = 1 - activeIdx;
    const $next = $bgs.eq(nextIdx);

    const reveal = () => {
      $next.css('opacity', 1);
      $current.css('opacity', 0);
      activeIdx = nextIdx;
    };

    if ($next.attr('src') === src) {
      reveal();

      return;
    }

    $next.one('load', reveal);
    $next.attr('src', src);
  }

  function cascadeText(title, description, author) {
    $content.addClass('is-hidden');
    setTimeout(() => {
      if (title) {
        $heading.text(title);
      }

      $description.html(description || '');

      $author.text(author || '');

      void $content[0].offsetHeight;
      $content.removeClass('is-hidden');
    }, TEXT_FADE);
  }

  function applyHeadingLink(targetUrl) {
    currentTargetUrl = targetUrl || '';
    $heading.toggleClass('is-clickable', currentTargetUrl !== '');
  }

  function activate(index) {
    const $thumb = $thumbs.eq(index);

    if (!$thumb.length) {
      return;
    }

    $thumbs.removeClass('is-active');
    $thumb.addClass('is-active');

    const data = $thumb.data();

    crossfadeBg(data.image);
    cascadeText(data.title, data.description, data.author);
    applyHeadingLink(data.targetUrl);
  }

  $thumbs.on('click', function () {
    activate($thumbs.index(this));
  });

  $heading.on('click', function () {
    if (currentTargetUrl === '') {
      return;
    }

    window.open(currentTargetUrl, '_blank', 'noopener');
  });

  applyHeadingLink($thumbs.eq(activeIdx).data('targetUrl'));
}
